export const ValidateAWSAccountID = (value: string | undefined) => {
  if (!value) {
    return true
  }
  const accountIds = value.split(',').map(id => id)
  return accountIds.every(id => /^\d{12}$/.test(id))
}
